<template>
  <div class="menu-container">
    <!-- 顶部导航栏 -->
    <nav class="top-nav">
      <nuxt-link class="logo" to="/">
        <img src="~/assets/images/logo.png" alt="Logo" />
        <div class="logo-info">
          <h1>ModuleMotion</h1>
          <p>Semicon Basic Module</p>
        </div>
      </nuxt-link>
      <div class="nav-items">
        <div
          v-for="(item, index) in menuItems"
          :key="index"
          class="nav-item"
          :class="[
            {
              active:
                item.link === route.path ||
                item.subMenus.indexOf(route.params?.id) > -1,
            },
            {
              hover: activeMenu === index,
            },
          ]"
          @click="toggleMenu(index)"
        >
          {{ item.title }}
        </div>
      </div>
    </nav>

    <!-- 二级菜单蒙层 -->
    <div
      class="submenu-overlay"
      v-if="activeMenu !== null"
      @click.self="closeMenu"
    >
      <div class="submenu-container">
        <!-- 左侧导航 -->
        <div
          class="sidebar"
          v-if="
            !(
              menuItems[activeMenu].subItems.length === 1 &&
              !menuItems[activeMenu].subItems[0].title
            )
          "
        >
          <div
            v-for="(subItem, subIndex) in menuItems[activeMenu]?.subItems"
            :key="subIndex"
            class="sidebar-item"
            :class="{ active: activeSubMenu === subIndex }"
            @click.stop="toggleSubMenu(subIndex)"
          >
            <el-icon class="sidebar-icon">
              <component :is="subItem.icon" />
            </el-icon>
            {{ subItem.title }}
            <el-icon v-if="subItem.children" class="arrow-icon"
              ><arrow-right
            /></el-icon>
          </div>
        </div>

        <!-- 右侧内容区域 -->
        <div
          class="content-area"
          v-if="
            activeSubMenu !== null &&
            menuItems[activeMenu]?.subItems[activeSubMenu]?.children
          "
        >
          <nuxt-link
            :to="child.link"
            v-for="(child, childIndex) in menuItems[activeMenu]?.subItems[
              activeSubMenu
            ]?.children"
            :key="childIndex"
            class="content-item"
            @click.stop="closeMenu"
          >
            <el-icon class="content-icon">
              <component :is="child.icon" />
            </el-icon>
            <div class="content-text">
              <h3>{{ child.title }}</h3>
              <p>{{ child.description }}</p>
            </div>
          </nuxt-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import {
  OfficeBuilding,
  ArrowRight,
  Setting,
  List,
  User,
  Star,
} from "@element-plus/icons-vue";
const route = useRoute();
// 菜单数据
const menuItems = [
  {
    title: "Home",
    link: "/",
    subMenus: [],
    subItems: null,
  },
  {
    title: "Company",
    subMenus: [
      "About-Us",
      "Leadership-Team",
      "Community-Involvement",
      "Job-Opportunities",
    ],
    subItems: [
      {
        title: "About",
        icon: Setting,
        children: [
          {
            title: "Our Story",
            description: "关于我们",
            icon: OfficeBuilding,
            link: "/page/About-Us",
          },
          {
            title: "Leadership Team",
            description: "我们的动态",
            icon: User,
            link: "/page/Leadership-Team",
          },
        ],
      },
      {
        title: "Careers",
        icon: Setting,
        children: [
          {
            title: "Job Opportunities",
            description: "加入我们",
            icon: Setting,
            link: "/page/Job-Opportunities",
          },
        ],
      },
    ],
  },
  {
    title: "Products & Services",
    subMenus: [
      "Products-&-Services",
      "Equipment-Automation",
      "OEM-Services",
      "Factory-Automation",
      "Test-Applications",
      "Factory-Services",
      "Equipment-Connectivity",
    ],
    subItems: [
      {
        title: "OEMs",
        icon: Setting,
        children: [
          {
            title: "Equipment Automation",
            description: "设备自动化功能集成，加速设备交付",
            icon: Setting,
            link: "/page/Equipment-Automation",
          },

          {
            title: "OEM Services",
            description: "完整的研发测试工具链",
            icon: Setting,
            link: "/page/OEM-Services",
          },
          {
            title: "Free Trial",
            description: "免费试用",
            icon: Setting,
            link: "/page/Free-Trial",
          },
        ],
      },
      {
        title: "Factories",
        icon: Setting,
        children: [
          {
            title: "Factory Automation",
            description: "工厂自动化功能集成，保证效率和良率",
            icon: Setting,
            link: "/page/Factory-Automation",
          },
          {
            title: "Test Applications",
            description: "测试工具，快速验证设备能力",
            icon: Setting,
            link: "/page/Test-Applications",
          },
          {
            title: "Factory Services",
            description: "完整的工厂系统服务",
            icon: Setting,
            link: "/page/Factory-Services",
          },
        ],
      },
      {
        title: "Overview",
        icon: List,
        link: "/page/Products-&-Services",
      },
    ],
  },
  {
    title: "Resources",
    subMenus: ["SEMI-Standards", "SECS-Message-Language"],
    subItems: [
      {
        children: [
          {
            title: "SEMI Standards",
            description: "了解SEMI标准的基础知识",
            icon: Setting,
            link: "/page/SEMI-Standards",
          },
          {
            title: "SECS Message Language",
            description: "通用的SECS/GEM消息及数据元素的描述语言",
            icon: Setting,
            link: "/page/SECS-Message-Language",
          },
        ],
      },
    ],
  },
];

// 当前激活的菜单索引
const activeMenu = ref(null);
const activeSubMenu = ref(null);

// 切换一级菜单
const toggleMenu = (index) => {
  if (menuItems[index]?.link) {
    activeMenu.value = null;
    activeSubMenu.value = null;
    // navigateTo({ path: menuItems[index]?.link, replace: true });
    window.location.href = menuItems[index]?.link;
    return;
  }
  if (activeMenu.value === index) {
    // 如果点击的是当前激活的菜单，则关闭
    activeMenu.value = null;
    activeSubMenu.value = null;
  } else {
    // 否则激活点击的菜单
    activeMenu.value = index;
    activeSubMenu.value = menuItems[activeMenu.value].subItems.findIndex(
      (item, i) => {
        return item.children;
      }
    );
  }
};

// 切换二级菜单
const toggleSubMenu = (index) => {
  let subMenuLink = menuItems[activeMenu.value].subItems[index].link;
  if (subMenuLink) {
    navigateTo(subMenuLink);
    closeMenu();
  } else {
    if (activeSubMenu.value === index) {
      // 如果点击的是当前激活的二级菜单，则关闭
      activeSubMenu.value = null;
    } else {
      // 否则激活点击的二级菜单
      activeSubMenu.value = index;
    }
  }
};

// 关闭菜单
const closeMenu = () => {
  activeMenu.value = null;
  activeSubMenu.value = null;
};
</script>

<style lang="scss" scoped>
.menu-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #222;
  z-index: 2;
}

/* 顶部导航栏样式 */
.top-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #222;
  color: white;
  height: 70px;
  width: $maxWidth;
  margin: 0 auto;
}

.logo {
  position: relative;
  cursor: pointer;
  height: 40px;
  display: flex;
  align-items: center;
  img {
    height: 100%;
    flex-shrink: 0;
  }
  .logo-info {
    margin-left: 10px;
    color: white;
    h1 {
      font-size: 18px;
      font-weight: 700;
      margin: 0;
      line-height: 1.2;
    }
    p {
      font-size: 12px;
      font-weight: 300;
      margin: 0;
      letter-spacing: 0.4px;
      opacity: 0.8;
    }
  }
}

.nav-items {
  display: flex;
  align-items: center;
  height: 100%;
}

.nav-item {
  padding: 0 1.5rem;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  transition: background-color 0.3s;
}
.nav-item.active {
  background-color: rgba(30, 136, 229, 1) !important;
}
.nav-item:hover,
.nav-item.hover {
  background-color: #444;
}

.right-items {
  display: flex;
  align-items: center;
  margin-left: 2rem;
}

.icons {
  display: flex;
  gap: 1rem;
  margin-right: 1rem;
}

.icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.support-btn {
  background-color: transparent;
  color: white;
  border: 1px solid white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  margin-right: 1rem;
  cursor: pointer;
}

.language {
  margin-right: 1rem;
  cursor: pointer;
}

.search {
  cursor: pointer;
}

/* 二级菜单蒙层样式 */
.submenu-overlay {
  position: fixed;
  top: 70px;
  left: 0;
  width: 100%;
  height: calc(100vh - 70px);
  background-color: rgba(0, 0, 0, 0);
  z-index: 100;
}

.submenu-container {
  display: flex;
  background-color: #333;
  margin: 0 auto;
}

/* 左侧导航样式 */
.sidebar {
  width: 250px;
  background-color: #333;
  color: white;
  padding: 1rem 0;
}

.sidebar-item {
  display: flex;
  align-items: center;
  padding: 0.75rem 1.5rem;
  cursor: pointer;
  transition: background-color 0.3s;
  position: relative;
}

.sidebar-item:hover,
.sidebar-item.active {
  background-color: #444;
}

.sidebar-icon {
  margin-right: 0.75rem;
}

.arrow-icon {
  position: absolute;
  right: 1rem;
}

/* 右侧内容区域样式 */
.content-area {
  flex: 1;
  padding: 2rem;
  background-color: #444;
  color: white;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.content-item {
  cursor: pointer;
  display: flex;
  width: calc((100% - 20px * 2) / 3);
  padding: 1em;
  box-sizing: border-box;
  border-radius: 8px;
  &:hover {
    background-color: #555;
    border-bottom: 2px solid #1e88e5;
  }
}

.content-icon {
  font-size: 24px;
  margin-right: 1rem;
  color: #1e88e5;
}

.content-text h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1rem;
  color: #1e88e5;
}

.content-text p {
  margin: 0;
  font-size: 0.9rem;
  color: #ccc;
}

.sidebar-item.active {
  background-color: #1e88e5;
}

/* Element Plus 图标样式调整 */
.el-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.sidebar-icon {
  font-size: 18px;
}
</style>
